export const CREATE_GOAL = "CREATE_GOAL";
export const CREATE_GOAL_SUCCESS = "CREATE_GOAL_SUCCESS";
export const CREATE_GOAL_FAILED = "CREATE_GOAL_FAILED";

export const RESET_ERROR_GOAL_CREATION = "RESET_ERROR_GOAL_CREATION";

export const SET_CIFPLAN_TEMP = "SET_CIFPLAN_TEMP";
export const RESET_CIFPLAN_TEMP = "RESET_CIFPLAN_TEMP";
